import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';

class StaffAircraftModelsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      instruction: 0,
      instruction_subtype: 0,
      expiration: '',
      date_start: '',
      expiration_subtype: '',
      date_start_subtype: '',
      staff_id: this.props.staff_id,
      aircraft_model_id: null,
      aircraft_model_subtype_id: null,
      staff_aircraft_models: [],
      aircraft_models_list: [],
      aircraft_model_subtypes_list: [],
    };

    //bind específico
    // this.addAircraftModel = this.addAircraftModel.bind(this);
    // this.addAircraftModelSubtype = this.addAircraftModelSubtype.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && Array.isArray(newProps.staff_aircraft_models)) {
      this.setState({
        staff_aircraft_models: newProps.staff_aircraft_models,
        aircraft_models_list: newProps.aircraft_models_list,
        aircraft_model_subtypes_list: newProps.aircraft_model_subtypes_list,
        loaded: 1
      });
    }
  }

  // Fetch salvando a edição
  // addAircraftModel(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     aircraft_model_id: this.state.aircraft_model_id,
  //     date_start: this.state.date_start,
  //     expiration: this.state.expiration,
  //     instruction: this.state.instruction,
  //     only_active: this.state.only_active,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.refreshData();
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  // // Fetch salvando a edição
  // addAircraftModelSubtype(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.state.staff_id,
  //     aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
  //     date_start_subtype: this.state.date_start_subtype,
  //     expiration_subtype: this.state.expiration_subtype,
  //     instruction_subtype: this.state.instruction_subtype,
  //     only_active: this.state.only_active,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api_sigmec') + '/colaborador/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.refreshData();
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }

  // // Fetch ativando um item
  // ativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa frota?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       staff_id: this.state.staff_id,
  //       only_active: this.state.only_active,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/frota/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.refreshData();
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  // // Fetch deletando um item
  // desativar(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa frota?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //       staff_id: this.state.staff_id,
  //       only_active: this.state.only_active,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/frota/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.refreshData();
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }

  refreshData (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api_sigmec') + '/colaborador/frotas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_aircraft_models: responseJson.data, only_active: 0});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        } else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive (event) {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/colaborador/frotas/ativas/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_aircraft_models: responseJson.data, only_active: 1});
        }
        if(typeof event.message !== 'undefined') {
          self.props.handleAlert(event.message, event.status, 'open');
        }else {
          self.props.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  // addToRevision(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de associar essa frota a uma revisão de designação aberta?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api_sigmec') + '/colaborador/revisao/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });
  //   }
  // }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tituloFrotasDesignadas}</h3>
  <hr/>
  {(this.state.staff_aircraft_models === null || typeof this.state.staff_aircraft_models === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.nenhumaFrotaCadastrada}</em></small><hr/></div>
  :
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Aeronave}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Subtipo}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Vencimento}</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Instrucao}?</th>
          <th className="text-center">{this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Status}</th>
          {/* <th className="col-md-1 text-center">Ações</th> */}
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_aircraft_models).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_aircraft_models[k].aircraft_model}</td>
              <td className="text-center">{self.state.staff_aircraft_models[k].aircraft_model_subtype}</td>
              <td className="text-center">{self.state.staff_aircraft_models[k].expiration_str}</td>
              <td className="text-center">{self.state.staff_aircraft_models[k].instruction_str}</td>
              <td className="text-center">{(self.state.staff_aircraft_models[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Arquivado}</span>}</td>
              {/* <td className="text-center">
                {(self.state.staff_aircraft_models[k].active === 1) ?
                  <button className="btn btn-sm btn-danger" value={self.state.staff_aircraft_models[k].id} onClick={self.desativar}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_aircraft_models[k].id} onClick={self.ativar}><i className="fa fa-fw fa-power-off"></i></button>
                }
                <button className="btn btn-sm btn-primary" value={self.state.staff_aircraft_models[k].id} onClick={self.addToRevision}><i className="fa fa-fw fa-plus"></i></button>
              </td> */}
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  {/* <h3 className="page-title">Adicionar frota</h3>
  <hr/>
  <form onSubmit={this.addAircraftModel}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Frota:</label>
        <Select
          className="form-field-name"
          name="aircraft_model_id"
          value={this.state.aircraft_model_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
          options={this.state.aircraft_models_list}
        />
      </div>
      <div className="col-md-6 form-group">
        <label>Instrução:</label>
        <Select
          className="form-field-name"
          name="instruction"
          value={this.state.instruction}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'instruction')}
          options={[
            {value: 0, label: 'Não'},
            {value: 1, label: 'Sim'},
          ]}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Expiração:</label>
        <InputMask value={this.state.expiration}  maskChar={null} name="expiration" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar frota</button>
  </form>
  <hr/>
  <h3 className="page-title">Adicionar motor</h3>
  <hr/>
  <form onSubmit={this.addAircraftModelSubtype}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Adicionar Subtipo:</label>
        <Select
          className="form-field-name"
          name="aircraft_model_subtype_id"
          value={this.state.aircraft_model_subtype_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'aircraft_model_subtype_id')}
          options={this.state.aircraft_model_subtypes_list}
        />
      </div>
      <div className="col-md-6 form-group">
        <label>Instrução:</label>
        <Select
          className="form-field-name"
          name="instruction_subtype"
          value={this.state.instruction_subtype}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'instruction_subtype')}
          options={[
            {value: 0, label: 'Não'},
            {value: 1, label: 'Sim'},
          ]}
          required
        />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.date_start_subtype}  maskChar={null} name="date_start_subtype" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start_subtype')} placeholder="" />
      </div>
      <div className="col-md-6 form-group">
        <label>Expiração:</label>
        <InputMask value={this.state.expiration_subtype}  maskChar={null} name="expiration_subtype" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'expiration_subtype')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Adicionar motor</button>
  </form> */}
</div>
    );
  }
}

export default StaffAircraftModelsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffAircraftModelsTab.js